import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=52b0c2cc"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"
import style0 from "./ContentLoader.vue?vue&type=style&index=0&id=52b0c2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports